import React from "react";
import DebtOverview from "../components/DebtOverview";

function DebtPage({ rows }) {
  return <DebtOverview rows={rows} />;
}

export default DebtPage;

